import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125b52f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "レポート", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "検索0件HIT", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "デイリートレーニング", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ユーザ別トレーニング", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ユーザ別デイリートレーニング", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "個別ログイン状況", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "いいねランキング", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "おきにいりランキング", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "閲覧数ランキング", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Q&A登録数ランキング", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "コメント新着順Q&A", -1))

import { useStore } from "vuex";
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "project-box text-left" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_menu, {
                    "collapse-transition": false,
                    router: "",
                    class: "cancel-boarder-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "ProjectQuestionSearchResult",
                        route: { name: 'ProjectQuestionSearchResult', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "ProjectDailyLearningReport",
                        route: { name: 'ProjectDailyLearningReport', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "UserLearningReportIndex",
                        route: { name: 'UserLearningReportIndex', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "UserDailyLearningReportIndex",
                        route: { name: 'UserLearningReportIndex', params: { project_id: _ctx.$route.params.project_id }, query: { daily: 1 } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "ProjectUserLastAccessReport",
                        route: { name: 'ProjectUserLastAccessReport', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "IineRanking",
                        route: { name: 'IineRanking', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "FavoriteRanking",
                        route: { name: 'FavoriteRanking', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "ViewRanking",
                        route: { name: 'ViewRanking', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "QuestionCreatedRanking",
                        route: { name: 'QuestionCreatedRanking', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 8, ["route"]),
                      _createVNode(_component_el_menu_item, {
                        class: "bottom-boarder",
                        index: "CommentedQuestionList",
                        route: { name: 'CommentedQuestionList', params: { project_id: _ctx.$route.params.project_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }, 8, ["route"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})